import { useState } from 'react'

import { useTransition } from 'hooks/useTransitions'

import { Option } from 'components/elements/FloatingToolbar/types'

import FloatingToolbarListOption from 'components/elements/FloatingToolbar/ListItem'
import Icon from 'components/elements/Icon'

import styles from './accordionItem.module.scss'

type Props = {
  primary: Option
  options?: Option[]
}

const AccordionItem = ({ primary, options = [] }: Props) => {
  const [open, setOpen] = useState(false)

  const [transition, transitionState] = useTransition(open, {
    enteringClassName: styles.entering,
    exitingClassName: styles.exiting,
  })

  return (
    <>
      <FloatingToolbarListOption
        {...primary}
        keybind={<Icon name="chevron down" />}
        onClick={() => {
          setOpen(!open)

          if (primary.onClick) primary.onClick()
        }}
      />

      {transitionState !== 'hidden' && (
        <div ref={transition}>
          {options.map((option, index) => {
            if (option.hidden) return null

            return <FloatingToolbarListOption {...option} key={index} />
          })}
        </div>
      )}
    </>
  )
}

export default AccordionItem
